var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-container",
    { attrs: { size: "small" } },
    [
      _c("h3", [_vm._v(_vm._s(_vm.$t("resetPassword.title")))]),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            label: _vm.$t("resetPassword.email"),
            "label-for": "email",
            description: _vm.$t("resetPassword.description")
          }
        },
        [
          _c("b-form-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|email",
                expression: "'required|email'"
              }
            ],
            attrs: {
              id: "email",
              name: "email",
              type: "email",
              disabled: _vm.isLoading || _vm.isSucceeded,
              "data-vv-as": _vm.$t("resetPassword.email")
            },
            model: {
              value: _vm.email,
              callback: function($$v) {
                _vm.email = $$v
              },
              expression: "email"
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("email"),
                  expression: "errors.has('email')"
                }
              ],
              staticClass: "form__error"
            },
            [_vm._v(_vm._s(_vm.errors.first("email")))]
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isLoading && !_vm.isSucceeded
        ? _c(
            "b-button",
            {
              attrs: { disabled: !_vm.isValid, variant: "primary" },
              on: { click: _vm.reset }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("resetPassword.performReset")) +
                  "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-button",
        { attrs: { to: "/login", variant: "primary" } },
        [
          _c("icon", { attrs: { name: "arrow-right" } }),
          _vm._v(
            "\n      " + _vm._s(_vm.$t("resetPassword.performLogin")) + "\n  "
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isLoading ? _c("loading-indicator") : _vm._e(),
      _vm._v(" "),
      _vm.errorMsg
        ? _c("b-alert", { attrs: { variant: "danger", show: "" } }, [
            _vm._v(_vm._s(_vm.errorMsg))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isSucceeded
        ? _c("b-alert", { attrs: { variant: "info", show: "" } }, [
            _vm._v(_vm._s(_vm.$t("resetPassword.successMsg")))
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d451516", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d451516","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResetPasswordScreen.vue
// module id = null
// module chunks = 